import { render, staticRenderFns } from "./BusinessContacts.vue?vue&type=template&id=5d3d9e49&"
import script from "./BusinessContacts.vue?vue&type=script&lang=js&"
export * from "./BusinessContacts.vue?vue&type=script&lang=js&"
import style0 from "./BusinessContacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports